<template>
  <div>
    <LinkBankAccount :companyId="$route.query.companyId" />
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-7">
            <h4 class="primary-color font-600">
              {{ $t("text.cBank.transaction.title") }}
            </h4>
            <p class="light-grey-text mt-3">
              {{ $t("text.cBank.transaction.description") }}
            </p>
          </div>
          <div class="col-md-3 flexify">
            <vue-ctk-date-time-picker
              v-model="dateRange"
              :max-date="maxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :custom-shortcuts="customShortcuts"
              color="#4b2d73"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>
      </div>
      <div class="new-row">
        <div class="invoice-banner">
          <div>
            <div>
              <h6 class="font-600 primary-color">
                {{ $t("text.cBank.transaction.totalCredit") }}:
              </h6>
            </div>
            <div class="mt-2">
              <span
                ><span class="currency"></span
                ><span class="amount-figures primary-color"
                  >{{ company ? company.currencyCode : "" }}
                  {{ convertThousand(totalCredit) }}</span
                ><span class="bold-span primary-color"></span
              ></span>
            </div>
            <div class="mt-2"></div>
          </div>
          <div>
            <div>
              <h6 class="font-600 primary-color">
                {{ $t("text.cBank.transaction.totalDebit") }}:
              </h6>
            </div>
            <div class="mt-2">
              <span
                ><span class="currency"></span
                ><span class="amount-figures primary-color"
                  >{{ company ? company.currencyCode : "" }}
                  {{ convertThousand(totalDebit) }}</span
                ><span class="bold-span primary-color"></span
              ></span>
            </div>
          </div>
          <div>
            <div>
              <h6 class="font-600 primary-color">
                {{ $t("text.cBank.transaction.balance") }}:
              </h6>
            </div>
            <div class="mt-2">
              <span
                ><span class="currency"></span
                ><span class="amount-figures primary-color"
                  >{{ company ? company.currencyCode : "" }}
                  {{ convertThousand(transactions.balance) }}</span
                ><span class="bold-span primary-color"></span
              ></span>
            </div>
            <div class="mt-2"></div>
          </div>
        </div>
      </div>
      <div
        class="empty-info-wrapper new-row mt-3"
        v-if="!showLoader && transactions && transactions.length < 1"
      >
        <img src="@/assets/img/bank-building (2) (2).svg" width="50" />
        <p class="light-grey-text mt-5">
          {{ $t("text.cBank.transaction.noTransaction") }}
        </p>
        <small class="light-grey-text">{{
          $t("text.cBank.transaction.accountDisplayed")
        }}</small>
        <div class="mt-5"></div>
      </div>
      <section class="new-row mt-3">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :allowTextWrap="true"
          :rowDataBound="rowDataBound"
          :excelQueryCellInfo="excelQueryCellInfo"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="80" field="index" headerText="#"></e-column>
            <e-column
              width="150"
              field="bankAccount.dateLinked"
              :headerText="$t('text.cBank.date')"
              :format="formatOptions"
              type="date"
            ></e-column>
            <e-column
              width="180"
              field="bankAccount.name"
              :headerText="$t('text.cBank.bank')"
            ></e-column>
            <e-column
              width="180"
              field="credit"
              :headerText="$t('text.cBank.credit')"
              format="N2"
            ></e-column>
            <e-column
              width="180"
              field="debit"
              :headerText="$t('text.cBank.debit')"
              format="N2"
            ></e-column>
            <e-column
              width="180"
              field="balance"
              :headerText="$t('text.cBank.transaction.balance')"
              format="N2"
            ></e-column>
            <e-column
              width="220"
              field="bankAccount.accountName"
              :headerText="$t('text.cBank.accountName')"
            ></e-column>
            <e-column
              width="180"
              field="bankAccount.accountNumber"
              :headerText="$t('text.cBank.accountNumber')"
            ></e-column>
            <e-column
              width="100"
              field="bankAccount.linked"
              :headerText="$t('text.cBank.linked')"
            ></e-column>
            <e-column
              width="180"
              field="bankAccount.linkedService"
              :headerText="$t('text.cBank.linkedService')"
            ></e-column>
            <e-column
              width="250"
              :template="template"
              :headerText="$t('text.cBank.action')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader"></TableLoader>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import CompanyLiveTransactionsBreakdown from "@/components/Templates/companyLiveTransactionsBreakdown.vue";
import VueMomentsAgo from "vue-moments-ago";
import LinkBankAccount from "@/components/modals/linkBankAccount.vue";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Link Bank Account:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    LinkBankAccount,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      transactions: {},
      totalCredit: 0,
      totalDebit: 0,
      searchTerm: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy " },
      showLinkedBanks: false,
      banks: [],
      branch: {},
      bankNames: [],
      branchId: null,
      showLoader: true,
      company: null,
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(30, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(30, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      template: function () {
        return {
          template: CompanyLiveTransactionsBreakdown,
        };
      },
    };
  },
  computed: {
    linkedBanks() {
      return this.banks.filter((bank) => bank.linked === true);
    },
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getLiveBankTransactions();
      }
    },
    searchTerm() {
      this.getLiveBankTransactions();
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getLiveBankTransactions();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getLiveBankTransactions();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },
  mounted() {},
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "dateLinked") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    // getBanks() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Branch/Banks`,
    //       configObject.authConfig()
    //     )
    //     .then((response) => {
    //       this.bankNames = response.data;
    //     })
    //     .catch((error) => {});
    // },
    rowDataBound: function (args) {
      if (args.data["status"] === "PENDING") {
        args.row.cells[9].style.color = "red";
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getLiveBankTransactions() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/LiveBankTransactions/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.transactions = response.data;
          response.data.accounts.forEach((el, index) => {
            el.index = index + 1;
            el.bankAccount.linked = el.bankAccount.linked ? "Yes" : "No";
            el.credit = el.credit;
            el.debit = el.debit;
          });
          this.totalCredit = response.data.accounts.reduce(
            (acc, cur) => (acc += cur.credit),
            0
          );

          this.totalDebit = response.data.accounts.reduce(
            (acc, cur) => (acc += cur.debit),
            0
          );

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.accounts,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
